const CREDENTIAL_ROUTES = ["r", "link", "claim"] as const;

function looksLikeIdentifier(segment: string): boolean {
  if (!segment) return false;

  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment)) {
    return true;
  }

  if (/^[a-z0-9]+(-[a-z0-9]+)+$/.test(segment)) {
    const longestRun = Math.max(...segment.split("-").map((part) => part.length));
    return longestRun >= 12;
  }

  if (segment.length >= 12 && /[a-z]/.test(segment) && /[A-Z0-9]/.test(segment)) {
    return true;
  }

  return segment.length >= 20;
}

export function redactAnalyticsPath(pathname: string): string {
  for (const route of CREDENTIAL_ROUTES) {
    const prefix = `/${route}/`;
    if (pathname.startsWith(prefix)) return `${prefix}[redacted]`;
  }

  return pathname
    .split("/")
    .map((segment) => (looksLikeIdentifier(segment) ? "[id]" : segment))
    .join("/");
}

/**
 * Vercel receives the resolved browser URL, so referral codes, scanner tokens,
 * invite tokens and record ids must be removed before the event leaves the
 * device. Query strings and fragments are discarded because a future route can
 * move a credential into `?token=` without changing this control.
 */
export function redactAnalyticsUrl(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    url.pathname = redactAnalyticsPath(url.pathname);
    url.search = "";
    url.hash = "";
    return url.toString();
  } catch {
    return null;
  }
}
